import {
	useTopicPageData,
	useTopicPagePaginatedRecentPetitionsData,
	useTopicPagePaginatedTrendingPetitionsData,
	useTopicSupporterVoicesData,
} from '#src/app/pages/topic/pageContext';
import { useQueryParamValue } from '#src/app/shared/hooks/location';
import { useTrackView } from '#src/app/shared/hooks/tracking';

export function useTrackPageView(): void {
	const {
		data: { totalCount: recentPetitionCount },
	} = useTopicPagePaginatedRecentPetitionsData();

	const {
		data: { totalCount: trendingPetitionCount },
	} = useTopicPagePaginatedTrendingPetitionsData();

	const {
		data: { name, photos },
	} = useTopicPageData();

	const {
		data: { totalCount: supporterVoicesCount },
	} = useTopicSupporterVoicesData();

	const sourceLocation = useQueryParamValue('source_location');

	useTrackView('topic_page_view', {
		topic_name: name,
		hero_image: photos[0]?.heroMedium?.url ? 'yes' : 'no',
		total_topic_petitions: recentPetitionCount + trendingPetitionCount,
		show_supporter_voices: supporterVoicesCount > 0,
		source_location: sourceLocation,
	});
}
